import { desaturate, lighten } from "polished";
import styled from "@emotion/styled";
var StyledList = /*#__PURE__*/ styled("ul", {
    target: "esy1fax0"
})("position:absolute;left:0;top:3.5rem;z-index:50;margin:0;padding:0;width:100%;max-height:400px;overflow-y:auto;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";border:0.125rem solid\n    ", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";border-radius:0.5rem;box-shadow:0 4px 6px -1px rgb(0 0 0 / 10%),0 2px 4px -2px rgb(0 0 0 / 10%);font-size:1rem;line-height:1.5;list-style-type:none;@media (max-height:250px){top:2.75rem;max-height:55vh;}@media (max-width:319px){top:2.75rem;max-height:60vh;}");
var ListItem = /*#__PURE__*/ styled("li", {
    target: "esy1fax1"
})("&:not(:first-of-type){border-top:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";}");
var StyledButton = /*#__PURE__*/ styled("button", {
    target: "esy1fax2"
})("display:inline-grid;grid-template:auto / 1.5rem 1fr;gap:0 0.5rem;align-items:center;margin:0;padding:0.75rem;border:0;outline:0;width:100%;font:inherit;text-align:left;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background:none;cursor:pointer;@media (max-width:319px){display:block;}&:hover,&:focus-visible{color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";}");
var IconWrapper = /*#__PURE__*/ styled("span", {
    target: "esy1fax3"
})("grid-row:1 / span 2;display:flex;@media (max-width:319px){display:none;}svg{fill:currentcolor;}");
var Price = /*#__PURE__*/ styled("data", {
    target: "esy1fax4"
})("display:block;font-size:0.875rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";");
var ErrorMessage = /*#__PURE__*/ styled("div", {
    target: "esy1fax5"
})("position:absolute;left:0;top:100%;background-color:#bf3d1f;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-size:0.75rem;border:0;border-radius:0;box-shadow:0 1px 3px rgb(0 0 0 / 30%);padding:1rem;z-index:3;");
export { ListItem, StyledList, StyledButton, Price, IconWrapper, ErrorMessage };
